import React from "react"

const SlicesResultsContext = React.createContext({})
const SlicesContext = React.createContext({})
const SlicesMapContext = React.createContext({})
const SlicesPropsContext = React.createContext({})

export {
  SlicesResultsContext,
  SlicesContext,
  SlicesMapContext,
  SlicesPropsContext,
}
